import { View } from 'react-native';

import { BodySemibold } from './BodySemibold';
import { Eyebrow } from './Eyebrow';
import { Section } from './Section';

const CONTEXT_WORDS = [
  'Ground ops',
  'Lab benches',
  'Event load-in',
  'Pre-op',
  'Maintenance',
];

export function ContextStrip() {
  return (
    <Section className="border-y border-border-strong bg-well py-5">
      <View className="flex-row flex-wrap items-center justify-center gap-x-7 gap-y-3.5">
        <Eyebrow className="text-[11px] tracking-[0.14em] text-faint">
          Run anywhere the work happens
        </Eyebrow>
        {CONTEXT_WORDS.map((word, i) => (
          <View key={word} className="flex-row items-center gap-x-7">
            {i > 0 ? <View className="h-1 w-1 rounded-full bg-border-strong" /> : null}
            <BodySemibold className="text-sm text-foreground-secondary">
              {word}
            </BodySemibold>
          </View>
        ))}
      </View>
    </Section>
  );
}
